<template>
  <div class="page-content">
    <div class="steps-box">
      <Steps :current="2">
        <Step
          title="提交订单"
        ></Step>
        <Step
          title="去支付"
        ></Step>
        <Step
          :title="orderStatusDesc"
        ></Step>
      </Steps>
    </div>
    <div class="pay-info">
      <Icon
        type="ios-checkmark-circle"
        color="#11CB64"
        size="60"
      />
      <div class="pay-result-text">
        {{ orderStatusDesc }}
      </div>
      <div class="info-item">
        <span class="pay-info-label">订单编号：</span>
        <span>{{ detail.orderNo || $route.query.orderNo }}</span>
      </div>
      <div class="info-item">
        <span class="pay-info-label">付款金额：</span>
        <span>{{ detail.payFee | moneyFix }}元</span>
      </div>
      <div class="info-item">
        <span class="pay-info-label">下单时间：</span>
        <span>{{ detail.orderTime }}</span>
      </div>
    </div>
    <div class="footer-box">
      <Button
        v-if="detail.serviceUrl"
        type="primary"
        @click="goMyApp"
      >
        前往我的应用
      </Button>
    </div>
  </div>
</template>
<script>
import {Steps,Step} from 'view-design';

export default {
  components: {
    Steps,
    Step,

  },
  data(){
    return {
      detail: {},
      orderStatusDesc: '支付完成',
    };
  },
  computed: {
   
  },
  created(){
    // 获取产品详情
    this.getDetail();
  },
  methods: {
    // 获取产品详情
    getDetail(){
      const {orderNo} = this.$route.query;
      // const url = '/paycenter-charge/api/facade/order/payResult';
      const url ='/paycenter-charge/api/worktable/order/payResult';
      const params = {
        orderNo,
      };
      this.$http.get(url,params).then((res) => {
        if (res.success){
          this.detail = res.data;
          const {orderStatus} = this.detail;
          if (orderStatus===3){
            this.orderStatusDesc = '汇款支付已提交';
          } else {
            this.orderStatusDesc = '支付完成';
          }
        } else {
          this.$Message.warning(res.message||'获取产品详情失败');
        }
      });
    },
    // 我的应用
    goMyApp(){
      window.location.href = this.detail.serviceUrl;
      // this.$router.push({
      //   path: '/app/market/index',
      //   query: {
      //     appType: 'myApp',
      //   },
      // });
    },
  },
};
</script>
<style lang="less" scoped>
.page-content {
  background-color: #fff;
  padding-bottom: 100px;
}
.steps-box {
  padding-top: 30px;
  width: 600px;
  margin: 0  auto 50px;
}
.pay-info {
  text-align: center;
  .pay-result-text {
    font-size: 16px;
    font-weight: bold;
    padding: 10px 0;
  }
  .info-item {
    padding: 5px 0;
    color: #999;
    width: 240px;
    margin: 0 auto;
    text-align: left;
    white-space: nowrap;
    .pay-info-label {
      display: inline-block;
      width: 70px;
      text-align: right;
    }
  }
}
.footer-box {
  padding-top: 50px;
  text-align: center;
}
</style>